/* istanbul ignore file */
import styled from 'styled-components';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { Text } from 'components/Div/styles';
import { EConsultDeleteIcon } from '@econsult/econsult-ui/dist/assets';

export const SummarySubTitle = styled.h3`
  color: ${({ theme }) => theme.summarySubtitle};
  font-family: Museo Sans, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.2px;
  margin: 0;
  margin-bottom: 0;
`;

export const SummaryDescription = styled.p`
  color: ${({ theme }) => theme.summaryContent};
  font-family: Myanmar Sans Pro, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  margin-top: 0;
  margin-bottom: 1rem;
`;

export const SummaryHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 8px;
`;

export const FlexGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 16px;

  @media (max-width: 600px) {
    gap: 0.75rem;
    justify-content: flex-end;
  }
`;

export const SaveStatusMessage = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: #333333;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  margin-bottom: 0;
  text-align: center;
  width: auto;
  max-width: 100%;

  @media (max-width: 900px) {
    width: 100%;
    display: block;
  }
`;

export const ButtonWrapper = styled.div<{ turnGreen: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0.75rem auto;
  padding: 0.75rem 1rem;
  gap: 0.75rem;
  border-radius: 0.75rem;
  background: ${({ turnGreen }) => (turnGreen ? '#DFF1D8' : '#F8F6F7')};
  transition: background-color 0.3s ease;

  & > * {
    flex: 1;
    min-width: 1;
  }
`;

export const SummaryTitle = styled(Text).attrs({ typography: 'ParagraphSmallHeavy' })`
  font-size: 22.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  margin: 0;

  @media (max-width: 600px) {
    font-size: 20px;
    padding: 0.25rem 0;
  }
`;

export const PresentingComplaintHeading = styled(Text).attrs({ typography: 'ParagraphBaseRegular' })`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  margin: 0;
  margin-top: 4px;
  padding: 0.25rem 0;
`;

export const SummaryHeaderButton = styled(Button).attrs(({ id, children }) => ({
  id: id || `button-${children?.toString().toLowerCase().replace(/\s+/g, '-')}`,
}))`
  height: 32px;
  width: 80px;
  font-size: 14px;
  svg {
    margin: 0;
    margin-right: 6px;
    fill: ${({ theme }) => theme.colorPrimaryPrimary100};
  }
`;

export const FeedbackButton = styled(Button).attrs(({ id, children }) => ({
  id: id || `button-${children?.toString().toLowerCase().replace(/\s+/g, '-')}`,
}))`
  height: 28px;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  background: ${({ theme }) => theme.colorSecondarySecondary100};
  border-color: ${({ theme }) => theme.colorSecondarySecondary100};
`;

export const ConfirmButton = styled(Button).attrs(({ id }) => ({
  id: id || 'Confirm-edit-button',
}))`
  background-color: #00638A;
  color: #FFFFFF;
  border: 2px solid transparent;
  padding: 12px 16px;
  gap: 4px;
  width: 306px;
  height: 40px;
  font-family: 'Museo Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;

  &:hover {
    background-color: #004A6E;
    border-color: #003F5C;
  }
`;

export const DiscardButtonOld = styled(Button).attrs(({ id }) => ({
  id: id || 'discard-button',
}))<{ turnPrimary?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  height: 40px;
  background: ${({ turnPrimary }) => (turnPrimary ? '#002B5B' : '#F3F3F3')};
  border-radius: 8px;
  border: none;
  font-family: 'Museo Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ turnPrimary }) => (turnPrimary ? '#FFFFFF' : '#002B5C')};

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const StyledDeleteIcon = styled(EConsultDeleteIcon)`
  height: 15px !important;
  width: 15px !important;
`;

export const GenericEcButton = styled(Button).attrs(({ id, children }) => ({
  id: id || `button-${children?.toString().toLowerCase().replace(/\s+/g, '-')}`,
}))`
  height: 32px;
  min-width: 80px;
  font-size: 14px;
  svg {
    margin: 0;
    margin-right: 6px;
    fill: ${({ theme }) => theme.colorPrimaryPrimary100};
  }
`;

export const TranscriptContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  margin-top: 20px;
  padding: 15px;
  background-color: #F9F9F9;
  border-radius: 8px;
  border: 1px solid #DDDDDD;

  h3 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  pre {
    font-size: 14px;
    color: #333333;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
`;
